import * as PubSubActionType from '../services/constants';
import * as NotifyActionType from './constants';
import PubSub from '../services/pubsub-service';
import { scrollToTop } from '../helper/unit-helper';

export default function NotificationStore(state, action) {
  switch (action.type)
  {
    case NotifyActionType.NOTIFY_SUCCESS:
      scrollToTop();
      PubSub.publish(PubSubActionType.TOAST_SUCCESS, { msg: action.data});
      return state;
    case NotifyActionType.NOTIFY_ERROR:
      if (!action.data) { return null; }
      scrollToTop();
      PubSub.publish(PubSubActionType.TOAST_ERROR, { msg: action.data});
      return state;

    case NotifyActionType.ROOT_NOTIFY_SUCCESS:
      PubSub.publish(PubSubActionType.ROOT_TOAST_SUCCESS, { msg: action.data});
      return state;
    case NotifyActionType.ROOT_NOTIFY_ERROR:
      PubSub.publish(PubSubActionType.ROOT_TOAST_ERROR, { msg: action.data});
      return state;
    default:
      break;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/Notification/reducers.js